import React, {ReactNode, useMemo} from 'react'
import {Button, Container, Loading} from 'grilnica-reactstrap'
import {PushClientDTO} from 'grilnica-store-share'
import {NotificationListItem} from './components/NotificationListItem'
import {chevronDownSVG, chevronUpSVG} from '../../../../components/svg/SystemIcons'
import {getStaticUrl} from '../../../../../utils/static'

interface NotificationListPageComponentProps {
  messages: PushClientDTO[]

  isShowHidden: boolean
  setIsShowHidden: (newValue: boolean) => void
}

const NotificationListPageComponent: React.FC<NotificationListPageComponentProps> = ({
  messages,
  isShowHidden,
  setIsShowHidden,
}): React.ReactElement => {
  const getNotificationListItem = useMemo(() => {
    if (messages) {
      const items: ReactNode[] = []
      if (messages?.length > 0) {
        for (const message of messages) {
          if (isShowHidden && message.isHidden) {
            items.push(<NotificationListItem key={message.pushQueueId} message={message} />)
          } else if (!isShowHidden && !message.isHidden) {
            items.push(<NotificationListItem key={message.pushQueueId} message={message} />)
          }
        }
      }

      if (items.length === 0) {
        return (
          <div className={'text-center mb-x8 mt-x4'}>
            <img
              src={getStaticUrl('/img/notification-img.svg')}
              alt={'Уведомления'}
              title={'Уведомления'}
              className={'mb-x8'}
            />
            <p className={'notification-list-empty-p mb-0'}>Список пуст</p>
          </div>
        )
      } else {
        return <div className={'notification-list'}>{items}</div>
      }
    } else {
      return <Loading />
    }
  }, [isShowHidden, messages])

  return (
    <Container size={'normal'} className={'mt-x10 mb-x10'}>
      <div className={'notification-list-header'}>
        <h1 className={'notification-list-h1'}>Уведомления</h1>
        <Button
          size={'sm'}
          style={'text'}
          color={'primary'}
          iconPosition={'right'}
          iconPath={isShowHidden ? chevronUpSVG : chevronDownSVG}
          isRoundedButton
          onClick={() => {
            setIsShowHidden(!isShowHidden)
          }}
          className={'ml-x2'}>
          {isShowHidden ? 'Скрытые' : 'Актуальные'}
        </Button>
      </div>
      {getNotificationListItem}
    </Container>
  )
}

export {NotificationListPageComponent}
